import React from 'react'
import {CardContent, styled} from '@mui/material'
import CardAtom from '../card/card.atom'
import card_loginStyles from './card_login.styles'
import BoxAtom from '../box/box.atom'

const Content = styled(CardContent)`
  ${card_loginStyles}
`
const CardLoginAtom: React.FC = function ({children}) {
  return (
    <BoxAtom display="flex" alignItems="center" width="100%" height="100%">
      <CardAtom ap_type="login">
        <Content>{children}</Content>
      </CardAtom>
    </BoxAtom>
  )
}

export default CardLoginAtom
